import React, { ComponentProps, useState } from "react";

import { SoilPlus3Menu, SoilPlus3MenuTrigger } from "components";

// every table row has a menu, but few are ever opened, so the menu's hooks and items only mount on the first click
export const LazySoilPlus3Menu = (menuProps: ComponentProps<typeof SoilPlus3Menu>) => {
  const [isMenuMounted, setIsMenuMounted] = useState(false);

  if (isMenuMounted) return <SoilPlus3Menu {...menuProps} defaultVisible />;

  return (
    <div className="context-menu-container">
      <SoilPlus3MenuTrigger onOpen={() => setIsMenuMounted(true)} />
    </div>
  );
};
